import React, { Component } from "react";
import Cookies from "js-cookie";

import LayoutOperation from "../../../components/layout_operation";
import Digital_dashborad from "./dashboard_digital";
import Static_dashborad from "./dashboard_static";
import Bus_dashborad from "./dashboard_bus";
import Airport_dashborad from "./dashboard_airport";

class Dashboard extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            check_type: "",
            operator_id: ""
        }
    }
    componentDidMount() {
        var setUrl = window.location.href.split("/");
        if ( window.location.href.includes("Mobile")) {
            this.setState({
                check_type: 1,
                operator_id: setUrl[setUrl.length - 1]
            })
        } else {
            this.setState({
                check_type: 0
            })
        }

    }

    render() {
        return (
            <>
                {this.state.check_type === 0 ?
                    <LayoutOperation active={0}>
                        {parseInt(Cookies.get("operator_id")) === 1 ? <Digital_dashborad status={this.state.check_type}  /> : null}
                        {parseInt(Cookies.get("operator_id")) === 2 ? <Static_dashborad status={this.state.check_type} /> : null}
                        {parseInt(Cookies.get("operator_id")) === 3 ? <Bus_dashborad status={this.state.check_type} /> : null}
                        {parseInt(Cookies.get("operator_id")) === 4 ? <Airport_dashborad status={this.state.check_type} /> : null}
                    </LayoutOperation>
                    :
                    <>
                        {parseInt(this.state.operator_id) === 1 ? <Digital_dashborad status={this.state.check_type} /> : null}
                        {parseInt(this.state.operator_id) === 2 ? <Static_dashborad status={this.state.check_type} /> : null}
                        {parseInt(this.state.operator_id) === 3 ? <Bus_dashborad status={this.state.check_type} /> : null}
                        {parseInt(this.state.operator_id) === 4 ? <Airport_dashborad status={this.state.check_type} /> : null}
                    </>


                }
            </>
        );
    }
}
export default Dashboard;